/* eslint-disable */

// The disclaimer popup html is generated in template _DisclaimerPopup.cshtml
import * as Cookies from 'js-cookie' 

export class DisclaimerPopup {
    constructor() {
        this.opts = {
            defaultCookieName: 'infopopup-count',
            loggedInCookieName: 'infopopup-count-logged-in',
            optanonCookieName: 'OptanonConsent',
            cookieExpire: 365*10,
            cookieDomain: '',
            popupVisibleClass: 'disclaimer-open',
            disclaimerPopupSelector: '.DisclaimerPopup',
            disclaimerAcceptBtnSelector: '#disclaimer-accept-btn',
            popupCountRequestUrl: '/api/umbmember/setinfopopupcount',
            popupLimit: 3, // The number of times the popup should be shown
        }
    }

    init() {
        this.disclaimerPopup = $(this.opts.disclaimerPopupSelector);

        if (!this.exists()) {
            return;
        }

        this.disclaimerAcceptBtn = $(this.opts.disclaimerAcceptBtnSelector);
        this.body = $('body');

        this.setCurrentInfoPopupCount();
        this.setListeners();
    }

    exists() {
        return this.disclaimerPopup && this.disclaimerPopup.length > 0;
    }

    /**
     * Check how many times the popup has been shown
     */
    setCurrentInfoPopupCount() {
        const memberInfo = window.memberInfo || {};
        
        const cookieCount = (this.getCookie() || 0);    
        const storedCount = memberInfo.infoPopupCount || this.getCookie(this.opts.loggedInCookieName) || 0;
        this.infoPopupCount = Math.min(this.opts.popupLimit, cookieCount + storedCount)
        
        if (memberInfo) {
            const storedCount = (memberInfo.infoPopupCount || 0)

            // If the popup was shown to user when logged out
            if (cookieCount > 0 && storedCount < this.opts.popupLimit) {
                this.sendInfoPopupCount()
            }
            
            this.removeCookie(this.opts.defaultCookieName);
            this.setCookie(this.opts.loggedInCookieName)
        }
    }

    show() {
        if (!this.exists()) {
            return;
        }
        
        if (this.infoPopupCount >= this.opts.popupLimit) {
            return;
        }

        if (this.body.hasClass(this.opts.popupVisibleClass)) {
            return;
        }
        
        this.infoPopupCount += 1;

        this.body.addClass(this.opts.popupVisibleClass);
    }

    setListeners() {
        this.disclaimerAcceptBtn.click((e) => {
            e.preventDefault()
            
            this.infoPopupCount++;

            if (window.memberInfo) {
                this.sendInfoPopupCount()
                // Popup count moved to database
                this.setCookie(this.opts.loggedInCookieName)
            }
            else {
                // Save popup count until user logins
                this.setCookie(this.opts.defaultCookieName)
            }
            
            this.body.removeClass(this.opts.popupVisibleClass);
        });

        if (typeof Optanon !== 'undefined') {
            Optanon.OnConsentChanged(() => {
                if (!this.isCookiesAccepted()) {
                    this.removePopupCookies();
                }
            });
        }
    }

    /**
     * Store popup count on server to keep track between devices
     */
    sendInfoPopupCount() {
        if (window.memberInfo) {
            const requestUrl = `${this.opts.popupCountRequestUrl}?count=${this.infoPopupCount}`

            $.post(requestUrl)   
        }
    }

    getCookie(cookieName) {
        cookieName = this.getCookieName(cookieName)
        const cookieVal = Cookies.get(cookieName, { domain: this.opts.cookieDomain })

        return parseInt(cookieVal) || 0
    }
    
    removePopupCookies() {
        this.removeCookie(this.opts.defaultCookieName)
        this.removeCookie(this.opts.loggedInCookieName)
    }

    removeCookie(cookieName) {
        cookieName = this.getCookieName(cookieName)
        Cookies.remove(cookieName)
    }
    
    isCookiesAccepted() {
        // OneTrust
        const consentCookie = Cookies.get(this.opts.optanonCookieName)

        // 3:0 means the user did not accept Functional Cookies
        if (consentCookie && consentCookie.indexOf("3:0") !== -1) {
            return false;
        }
        
        return true;
    }

    setCookie(cookieName) {
        if (!this.isCookiesAccepted()) {
            return;
        }
        
        cookieName = this.getCookieName(cookieName)
        Cookies.set(cookieName, this.infoPopupCount, {
            expires : this.opts.cookieExpire,
            domain  : this.opts.cookieDomain
        })
    }

    getCookieName(cookieName) {
        return cookieName ? 
            cookieName : 
            this.opts.defaultCookieName
    }
}

$(function() {
    window.DisclaimerPopup = new DisclaimerPopup();
    window.DisclaimerPopup.init();

    setTimeout(function() {
        window.DisclaimerPopup.show();
    }, 400);
});